export const AREA_FILTER_MODE = {
  DEFAULT: 'default',
  CUSTOM: 'custom',
  ALL: 'all',
  SEARCH: 'search',
} as const;

export type AreaFilterMode = (typeof AREA_FILTER_MODE)[keyof typeof AREA_FILTER_MODE];

export const INCIDENT_SCOPE = {
  AREA: 'AREA',
  WAREHOUSE: 'WAREHOUSE',
  ALL: 'ALL',
} as const;

export type IncidentScope = (typeof INCIDENT_SCOPE)[keyof typeof INCIDENT_SCOPE];

export const SCOPE_ACCESS = {
  EDIT: 'edit',
  READ_ONLY: 'read_only',
} as const;

export type ScopeAccess = (typeof SCOPE_ACCESS)[keyof typeof SCOPE_ACCESS];

export const SCOPE_QUERY_PARAM = {
  AREAS: 'areas',
} as const;

export const SCOPE_AREAS_VALUE = {
  DEFAULT: 'default',
  ALL: 'all',
} as const;

export const SCOPE_MENU_VALUE = {
  DEFAULT: 'default',
  ALL: 'all',
} as const;

export const SCOPE_FAILURE = {
  UNAUTHORIZED: 'unauthorized',
  FORBIDDEN: 'forbidden',
  UNAVAILABLE: 'unavailable',
} as const;

export type ScopeFailure = (typeof SCOPE_FAILURE)[keyof typeof SCOPE_FAILURE];

export const SCOPE_HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  UNPROCESSABLE: 422,
} as const;

export const NO_WAREHOUSE_LABEL = 'Sin almacén asignado';
export const NO_WAREHOUSE_MESSAGE =
  'Pide a un administrador que te asigne un almacén y un área para ver información aquí.';
export const ALL_AREAS_LABEL = 'Todas las áreas';
export const MY_AREAS_LABEL = 'Mis áreas';
export const MY_AREA_SUFFIX = 'tu área';
export const INACTIVE_AREA_SUFFIX = 'inactiva';
export const SCOPE_FILTER_LABEL = 'Filtrando por:';
export const SCOPE_FILTER_ARIA_LABEL = 'Filtro activo';
export const SCOPE_FILTER_BAR_LABEL = 'Área';

export const SCOPE_FILTER_PLACEMENT = {
  HEADER: 'header',
  BAR: 'bar',
} as const;

export type ScopeFilterPlacement =
  (typeof SCOPE_FILTER_PLACEMENT)[keyof typeof SCOPE_FILTER_PLACEMENT];
export const SCOPE_SEARCH_HINT = 'Buscando en todas las áreas del almacén';
export const SCOPE_REJECTED_MESSAGE =
  'El área seleccionada ya no está disponible. Se restauró tu filtro.';

export const INCIDENT_SCOPE_LABEL = {
  WAREHOUSE: 'Todas las áreas',
  ALL: 'Todos los almacenes',
} as const;

export interface ScopeWarehouse {
  code: string;
  name: string;
}

export interface ScopeArea {
  id: string;
  name: string;
}

export interface ScopeWarehouseArea extends ScopeArea {
  active: boolean;
  isMine: boolean;
}

export interface AppliedFilter {
  mode: AreaFilterMode;
  warehouse: ScopeWarehouse | null;
  areas: ScopeArea[];
  label: string;
}

export interface MeScope {
  warehouse: ScopeWarehouse | null;
  areas: ScopeArea[];
  warehouseAreas: ScopeWarehouseArea[];
  defaultSelection: AppliedFilter;
  incidentScope: IncidentScope | null;
  canCreateSchedule: boolean;
}

export interface AreaSelection {
  mode: AreaFilterMode;
  areaIds: string[];
}

export interface ScopeLoadResult {
  scope: MeScope | null;
  failure: ScopeFailure | null;
}

export interface ScopeMenuOption {
  value: string;
  label: string;
  suffix: string | null;
}

export interface ScopeMenuOptions {
  options: ScopeMenuOption[];
  selectedValue: string | null;
}

export interface ScopeAreaApiItem {
  id?: string | null;
  name?: string | null;
}

export interface ScopeWarehouseApiItem {
  code?: string | null;
  name?: string | null;
}

export interface AppliedFilterApiItem {
  mode?: string | null;
  warehouse?: ScopeWarehouseApiItem | null;
  areas?: ScopeAreaApiItem[] | null;
  label?: string | null;
}

export interface ScopeFieldsApiItem {
  area?: ScopeAreaApiItem | null;
  warehouse?: ScopeWarehouseApiItem | null;
  is_foreign?: boolean | null;
}

export function buildDefaultAreaSelection(): AreaSelection {
  return { mode: AREA_FILTER_MODE.DEFAULT, areaIds: [] };
}
